import axios from "axios";

export default {
  data() {
    return {
      downloadsLoading: []
    };
  },
  methods: {
    getExcel(request) {
      this.downloadsLoading.push(request);

      axios
        .get(request, {
          headers: {
            Authorization: `Bearer ${this.$store.state.accessToken}`
          },
          responseType: "blob"
        })
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type }),
            url = window.URL.createObjectURL(blob);
          //window.open(url)

          // if we just use window.open(url), we cannot specify a filename, so we have to create an invisible <a> with a download attribute which is used for the filename
          let link = document.createElement("a");
          link.href = url;
          link.download = response.request.getResponseHeader("wisdom-filename"); // the filename
          link.click();

          this.downloadsLoading.splice(
            this.downloadsLoading.findIndex(item => item === request),
            1
          );
        })
        .catch(error => {
          console.log(error);
          console.log("why the!!!!!");
          this.downloadsLoading.splice(
            this.downloadsLoading.findIndex(item => item === request),
            1
          );
        });
    }
  }
};
